import { namespace } from 'd3-selection';

/**
 * This function is taken directly from the d3 package, except for a small change that makes it so we can clamp certain attributes to prevent
 * invalid property values, like negative numbers for 'width' or 'height',
 */
export function AttrTween(clampAttributes = []) {
  function attrInterpolate(name, i) {
    return function (t) {
      const value = i.call(this, t);

      // Clamping addition starts here
      for (const clampAttribute of clampAttributes) {
        if (name === clampAttribute.propertyName && typeof value === 'number') {
          this.setAttribute(name, Math.max(clampAttribute.min, value));

          return;
        }
      }
      // Clamping addition stops here

      this.setAttribute(name, value);
    };
  }

  function attrInterpolateNS(fullname, i) {
    return function (t) {
      const value = i.call(this, t);

      // Clamping addition starts here
      for (const clampAttribute of clampAttributes) {
        if (
          fullname === clampAttribute.propertyName &&
          typeof value === 'number'
        ) {
          this.setAttribute(fullname, Math.max(clampAttribute.min, value));

          return;
        }
      }
      // Clamping addition stops here

      this.setAttributeNS(fullname.space, fullname.local, value);
    };
  }

  function attrTweenNS(fullname, value) {
    let t0, i0;
    function tween() {
      // eslint-disable-next-line prefer-rest-params
      const i = value.apply(this, arguments);
      if (i !== i0) t0 = (i0 = i) && attrInterpolateNS(fullname, i);
      return t0;
    }
    tween._value = value;
    return tween;
  }

  function attrTween(name, value) {
    let t0, i0;
    function tween() {
      // eslint-disable-next-line prefer-rest-params
      const i = value.apply(this, arguments);
      if (i !== i0) t0 = (i0 = i) && attrInterpolate(name, i);
      return t0;
    }
    tween._value = value;
    return tween;
  }

  return function (name, value) {
    let key = 'attr.' + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    // This is D3's original implementation.
    // eslint-disable-next-line no-eq-null, eqeqeq
    if (value == null) return this.tween(key, null);
    if (typeof value !== 'function') throw new Error();
    const fullname = namespace(name);
    return this.tween(
      key,
      (fullname.local ? attrTweenNS : attrTween)(fullname, value),
    );
  };
}
